<template>
  <div>
    <div class="text-center piv">
      <label
        class="titrePage"
        style="font-size: 40px"
      >
        {{ $t("Paiement.TitrePage") }}
      </label>
    </div>
    <v-img class="imageFond h-100 pt-13 pb-13">
      <div>
        <v-col
          class="ml-auto mr-auto"
          cols="12"
        >
          <!--Panier-->
          <div class="boite">
            <Panier :estPanierPaiement="true" />
          </div>

        </v-col>
      </div>

      <div v-if="loadingPage">
        <v-col
          cols="12"
          class="text-center"
        >
          <v-progress-circular
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>
      </div>
      <div v-else>
        <!--Chargement-->
        <v-col cols="12">
          <v-progress-circular
            v-if="loadingPaiement"
            class="text-center"
            :size="50"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-col>

        <!--Paiement examen-->
        <v-col
          cols="12"
          v-if="inscriptionStore.estGratuit"
          class="text-center"
        >
          <div>
            <v-btn
              elevation="8"
              dark
              style="background-color: #095797;"
              :loading="loadingAchatGratuit"
              class="middle rounded boutonPrincipal"
              v-on:click.stop="EffectuerPaiementGratuit()"
            >
              {{$tc("Paiement.ConfirmationExamen")}}
            </v-btn>
          </div>
        </v-col>

        <!-- Inscription sans paiement -->
        <v-col
          v-else-if="estOrganismeGratuit || inscriptionStore.estDejaPaye"
          cols="12"
          class="text-center"
        >
          <div>
            <v-btn
              v-if="erreur == ''"
              elevation="8"
              dark
              style="background-color: #095797;"
              :loading="loadingAchatGratuit"
              class="middle rounded boutonPrincipal"
              v-on:click.stop="EffectuerPaiementGratuit()"
            >
              {{$tc("Paiement.ConfirmationCours")}}
            </v-btn>
          </div>
        </v-col>

        <!--Paiement paypal-->
        <v-col
          v-else-if="!inscriptionStore.estDejaPaye && !inscriptionStore.estGratuit && !estOrganismeGratuit && erreur == ''"
          cols="12"
          id="divPaypal"
        >
          <div class="backgroundPaypal">
            <div id="PaiementPaypal">
              <div
                id="divErreurPaypal"
                class="cssDivErreurPaypal d-none"
              >
                {{$tc("Paiement.erreur.erreurPaiement")}}
              </div>
            </div>
          </div>
        </v-col>

        <!--Erreurs-->
        <v-col
          cols="12"
          v-else-if="erreur != ''"
          class="text-center"
        >
          <div class="cssDivErreurPaypal d-block">
            {{$tc(erreur)}}
          </div>
        </v-col>

      </div>
    </v-img>

    <BoiteNousJoindre />
    <div class="petiteLigneRouge"></div>
  </div>
</template>

<script>
import { loadScript } from '@paypal/paypal-js';

import useAppStore from '@/store/appStore';
import usePaiementStore from '@/store/paiementStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import Panier from '../Panier/Panier.vue';

import BoiteNousJoindre from '../Accueil/BoiteNousJoindre.vue';

const racineLocalStorage = 'csqc_coursEte_';
const localStoragePanier = 'Panier';

export default {
  name: 'ProcederPaiement',
  components: {
    BoiteNousJoindre,
    Panier,
  },
  data() {
    return {
      informationPanierVM: {
        panier: [],
        eleveId: 0,
      },
      erreur: '',
      numFacture: '',
      factureId: '',
      loadingPage: false,
      loadingAchatGratuit: false,
      loadingPaiement: false,
      guidEleveEcole: null,
      estOrganismeGratuit: false,
    };
  },
  setup() {
    const appStore = useAppStore();
    const paiementStore = usePaiementStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return {
      appStore, paiementStore, inscriptionStore, panierStore,
    };
  },
  async created() {
    this.erreur = '';
    this.informationPanierVM.panier = this.panierStore.listeCoursPanier;
    this.informationPanierVM.eleveId = this.inscriptionStore.eleveId;

    // Obtention de l'élève
    const idEleve = this.informationPanierVM.eleveId;
    if (idEleve == null || idEleve === '') {
      window.location.href = `${this.appStore.modele.urlBase}/#/boutique`;
      return;
    }

    await this.paiementStore.definirEleveEcoleGuid(idEleve);
    this.guidEleveEcole = this.paiementStore.eleveEcoleGuid;

    // Si le guid est invalide, l'utilisateur est redirigé vers la boutique
    if (this.guidEleveEcole == null || this.guidEleveEcole === '' || this.guidEleveEcole === undefined) {
      window.location.href = `${this.appStore.modele.urlBase}/#/boutique`;
      return;
    }

    if (this.panierStore.listeCoursPanier.length === 0) {
      window.location.href = `${this.appStore.modele.urlBase}/#/boutique`;
    } else {
      try {
        this.loadingPage = true;
        await this.inscriptionStore.definirSiGratuit(this.informationPanierVM);
        await this.inscriptionStore.definirSiDejaPaye(this.informationPanierVM);

        if (this.informationPanierVM.panier != null && this.informationPanierVM.panier.some((x) => x.estGratuit)) {
          this.estOrganismeGratuit = true;
        } else {
          this.estOrganismeGratuit = false;
        }
        this.loadingPage = false;
      } catch (error) {
        this.erreur = error;
        this.loadingPage = false;
      } finally {
        this.loadingPage = false;
      }

      if (!this.inscriptionStore.estDejaPaye && !this.inscriptionStore.estGratuit && !this.estOrganismeGratuit && this.erreur === '') {
        const paypalpalSdk = await loadScript({
          'client-id': this.appStore.modele.paypalClientId,
          currency: 'CAD',
          locale: 'fr_CA',
        });

        this.loadingPaiement = false;

        this.informationPanierVM.panier = this.panierStore.listeCoursPanier;
        const informationPanierVM = JSON.stringify(this.informationPanierVM);
        let varFactureId = this.factureId;
        const lethis = this; // Nos instances this du component Paiement.vue. Le this dans le Sdk sert pour les trucs de PayPal

        paypalpalSdk
          .Buttons({
            style: {
              color: 'white',
            },
            // Call your server to set up the transaction
            createOrder() {
              // Remettre erreur par défaut
              document.getElementById('divErreurPaypal').innerHTML =
                'Un problème est survenu lors du paiement. Veuillez réessayer ou contactez la ligne de support. Merci.';

              this.appStore = useAppStore();
              return fetch(
                `${this.appStore.modele.urlBase
                }/api/EleveInscription/DemandeDePaiement`,
                {
                  method: 'post',
                  headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-OriginCommun': '*',
                    'X-Requested-With': 'XMLHttpRequest',
                  },
                  body: informationPanierVM,
                },
              )
                .then((res) => res.json())
                .then(function (data) {
                  // Valider erreur
                  if (data.code && data.code === 500) {
                    if (data.resultat) {
                      document.getElementById('divErreurPaypal').innerHTML =
                        lethis.$t(data.resultat);
                      this.loadingPaiement = false;
                      document.getElementById('PaiementPaypal').classList.remove('disabledDiv');
                    }
                    return; // En quittant ici, l'erreur paypal sera levé et la div affiché sur le onError plus bas.
                  }
                  varFactureId = data.factureId;

                  // eslint-disable-next-line consistent-return
                  return data.orderID;
                });
            },
            onApprove(data) {
              this.loadingPaiement = true;
              document.getElementById('PaiementPaypal').className += 'disabledDiv';
              this.appStore = useAppStore();
              return fetch(
                `${this.appStore.modele.urlBase
                }/api/EleveInscription/FinaliserPaiement`,
                {
                  method: 'post',
                  headers: {
                    'content-type': 'application/json',
                  },
                  body: JSON.stringify({
                    infosCourriel: {
                      lienConfirmation: `${this.appStore.modele.urlBase}/#/Paiement/Confirmation/${lethis.guidEleveEcole}`,
                      estPaiement: true,
                      eleveEcoleGuid: lethis.guidEleveEcole,
                    },
                    informationPanierVM: lethis.informationPanierVM,
                    paypalCaptureObject: {
                      orderID: data.orderID,
                      factureId: varFactureId,
                    },
                  }),
                },
              )
                .then((res) => res.json())
                .then(async function (details) {
                  // Valider erreur
                  if (details.code && details.code === 500) {
                    if (details.resultat) {
                      document.getElementById('divErreurPaypal').innerHTML =
                        lethis.$t(data.resultat);
                      this.loadingPaiement = false;
                      document.getElementById('PaiementPaypal').classList.remove('disabledDiv');
                    }
                    return; // En quittant ici, l'erreur paypal sera levé et la div affiché sur le onError plus bas.
                  }

                  // Retourne "COMPLETED" quand la transaction est complétée

                  const jsonCoursPanier = JSON.stringify([]);

                  localStorage.setItem(
                    racineLocalStorage + localStoragePanier,
                    jsonCoursPanier,
                  );

                  if (details.resultat.responseStatus === 'COMPLETED') {
                    await lethis.panierStore.definirListeCoursPanier([]);

                    // Modification de l'état de la colonne "EstListeAttente" de TbCoursEleve
                    await lethis.paiementStore.retirerEtatListeAttente(varFactureId);

                    // Redirection vers la page de confirmation
                    window.location.href =
                      `${lethis.appStore.modele.urlBase
                      }/#/Paiement/Confirmation/${lethis.guidEleveEcole}`; // lethis est important
                  }
                });
            },
            onError() {
              document.getElementById('divErreurPaypal').style.display = 'block';
            },
          })
          .render('#PaiementPaypal');
      }
    }
  },
  computed: {
  },
  methods: {
    async EffectuerPaiementExamen() {
      this.loadingAchatGratuit = true;
      await this.inscriptionStore.acheterPanierExamen(this.informationPanierVM);
      this.loadingAchatGratuit = false;
      const jsonCoursPanier = JSON.stringify([]);
      localStorage.setItem(
        racineLocalStorage + localStoragePanier,
        jsonCoursPanier,
      );
      await this.panierStore.definirListeCoursPanier([]);

      window.location.href = `${this.appStore.modele.urlBase}/#/Paiement/Confirmation/${this.guidEleveEcole}`;
    },
    async EffectuerPaiementGratuit() {
      this.loadingAchatGratuit = true;
      await this.inscriptionStore.acheterPanierGratuit(this.informationPanierVM);
      this.loadingAchatGratuit = false;
      const jsonCoursPanier = JSON.stringify([]);
      localStorage.setItem(
        racineLocalStorage + localStoragePanier,
        jsonCoursPanier,
      );
      await this.panierStore.definirListeCoursPanier([]);

      window.location.href = `${this.appStore.modele.urlBase}/#/Paiement/Confirmation/${this.guidEleveEcole}`;
    },
  },
};
</script>

<style type="text/css">
#loading {
    height: 100%;
    width:100%
}
#loadingDiv{
  text-align:center;
}

.backgroundPaypal {
  background-color: rgba(255, 255, 255, 0.6);
}

.disabledDiv {
  pointer-events: none;
  opacity: 0.4;
}

.middle {
  text-align: center;
  vertical-align: center;
  min-height: 55px;
  color: white;
  min-width: 200px;
  max-width: 750px !important;
  width: 100%;
}

.boite {
  position: relative;
  width: 100%;
  min-height: 35px;
  min-width: 200px;
  max-width: 750px !important;
  margin-left: auto;
  margin-right: auto;
}
.cssDivErreurPaypal {
  color: red;
  background-color: rgba(255, 255, 255, 0.3);
  padding: 15px;
}

/* Méchante grosse résolution ou vraiment trop dézoomé */
@media screen and (min-width: 5000px)  and (max-width: 10000px) {
  #PaiementPaypal {
    margin: auto !important;
    text-align: center !important;
    width: 10% !important;
    text-align: center;
    padding: 15px 0px 15px 0px;
  }
}

@media screen and (min-width: 3000px)  and (max-width: 5000px) {
  #PaiementPaypal {
    margin: auto !important;
    text-align: center !important;
    width: 20% !important;
    text-align: center;
    padding: 15px 0px 15px 0px;
  }
}

@media screen and (min-width: 1950px)  and (max-width: 3000px) {
  #PaiementPaypal {
    margin: auto !important;
    text-align: center !important;
    width: 30% !important;
    text-align: center;
    padding: 15px 0px 15px 0px;
  }
}

@media screen and (min-width: 1560px)  and (max-width: 1950px) {
  #PaiementPaypal {
    margin: auto !important;
    text-align: center !important;
    width: 40% !important;
    text-align: center;
    padding: 15px 0px 15px 0px;
  }
}

@media screen and (min-width: 0px)  and (max-width: 1560px) {
  #PaiementPaypal {
    margin: auto !important;
    text-align: center !important;
    width: 50% !important;
    text-align: center;
    padding: 15px 0px 15px 0px;
  }
}
</style>
